export default {
    'en': 'English',
    'es': 'Spanish',
    'pt': 'Portuguese'
};
